/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { AgencyEventRankingGroup } from "./Common/AgencyEventRankingGroup";

export const protobufPackage = "Reality.Reality.Api";

/**
 * <strong>POST /api/v2/agency_event/ranking/get_groups</strong>
 * 事務所イベントグループランキング情報を取得
 */
export interface AgencyEventRankingGetGroupsRequest {
  /** @deprecated */
  eventId: number;
  eventKey: string;
}

export interface AgencyEventRankingGetGroupsResponse {
  rankingList: AgencyEventRankingGroup[];
}

function createBaseAgencyEventRankingGetGroupsRequest(): AgencyEventRankingGetGroupsRequest {
  return { eventId: 0, eventKey: "" };
}

export const AgencyEventRankingGetGroupsRequest = {
  encode(message: AgencyEventRankingGetGroupsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.eventId !== 0) {
      writer.uint32(8).int64(message.eventId);
    }
    if (message.eventKey !== "") {
      writer.uint32(18).string(message.eventKey);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgencyEventRankingGetGroupsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgencyEventRankingGetGroupsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.eventId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.eventKey = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgencyEventRankingGetGroupsRequest {
    return {
      eventId: isSet(object.eventId) ? globalThis.Number(object.eventId) : 0,
      eventKey: isSet(object.eventKey) ? globalThis.String(object.eventKey) : "",
    };
  },

  toJSON(message: AgencyEventRankingGetGroupsRequest): unknown {
    const obj: any = {};
    if (message.eventId !== 0) {
      obj.eventId = Math.round(message.eventId);
    }
    if (message.eventKey !== "") {
      obj.eventKey = message.eventKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgencyEventRankingGetGroupsRequest>, I>>(
    base?: I,
  ): AgencyEventRankingGetGroupsRequest {
    return AgencyEventRankingGetGroupsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgencyEventRankingGetGroupsRequest>, I>>(
    object: I,
  ): AgencyEventRankingGetGroupsRequest {
    const message = createBaseAgencyEventRankingGetGroupsRequest();
    message.eventId = object.eventId ?? 0;
    message.eventKey = object.eventKey ?? "";
    return message;
  },
};

function createBaseAgencyEventRankingGetGroupsResponse(): AgencyEventRankingGetGroupsResponse {
  return { rankingList: [] };
}

export const AgencyEventRankingGetGroupsResponse = {
  encode(message: AgencyEventRankingGetGroupsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.rankingList) {
      AgencyEventRankingGroup.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgencyEventRankingGetGroupsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgencyEventRankingGetGroupsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.rankingList.push(AgencyEventRankingGroup.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgencyEventRankingGetGroupsResponse {
    return {
      rankingList: globalThis.Array.isArray(object?.rankingList)
        ? object.rankingList.map((e: any) => AgencyEventRankingGroup.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AgencyEventRankingGetGroupsResponse): unknown {
    const obj: any = {};
    if (message.rankingList?.length) {
      obj.rankingList = message.rankingList.map((e) => AgencyEventRankingGroup.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgencyEventRankingGetGroupsResponse>, I>>(
    base?: I,
  ): AgencyEventRankingGetGroupsResponse {
    return AgencyEventRankingGetGroupsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgencyEventRankingGetGroupsResponse>, I>>(
    object: I,
  ): AgencyEventRankingGetGroupsResponse {
    const message = createBaseAgencyEventRankingGetGroupsResponse();
    message.rankingList = object.rankingList?.map((e) => AgencyEventRankingGroup.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
